var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"habit-icon",class:`habit-icon--${_vm.tone}`,style:({ width: `${_vm.size}px`, height: `${_vm.size}px`, minWidth: `${_vm.size}px` })},[_c('v-icon',{attrs:{"size":Math.round(_vm.size * .5)}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }